// extracted by mini-css-extract-plugin
module.exports = {"root":"product-exp-quantity_root__GT2pK","button":"product-exp-quantity_button__1DYiY","text":"product-exp-quantity_text__2Q-51","dropdown":"product-exp-quantity_dropdown__4E2Rb"};